// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2VUAl","colMaxWidth":"Table_colMaxWidth__1h9J1"};